/**
 * Audio entry point. `initAudio()` (called once from main.tsx) wires the bus `sound` requests,
 * the ambience bed and the signals cues, and unlocks the AudioContext on the first user gesture
 * (browser autoplay policy) — nothing makes a sound before the player has touched the page.
 * Volumes (master, ambience, effects) and mute live in `settingsStore`; see mixer.ts.
 */
import { startAmbience } from './ambience';
import { startCues } from './cues';
import { unlockAudio } from './mixer';
import { listenForSounds } from './sfx';

export { playSound } from './sfx';

export function initAudio(): () => void {
  const unlock = () => {
    if (unlockAudio()) {
      window.removeEventListener('pointerdown', unlock);
      window.removeEventListener('keydown', unlock);
    }
  };
  window.addEventListener('pointerdown', unlock);
  window.addEventListener('keydown', unlock);
  const offs = [listenForSounds(), startAmbience(), startCues()];
  return () => {
    for (const off of offs) off();
    window.removeEventListener('pointerdown', unlock);
    window.removeEventListener('keydown', unlock);
  };
}
